import { defaultLanguageFluencyData } from '../../../../backend/config/classifiers/defaults/DefaultLanguageFluencyData';
import { languageFluencySchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers, allowManageSkillsAndTrainingsClassifiers } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const languageFluencyEntityName = 'languageFluency';
const languageFluencyColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { displayOrder: {
        type: 'number',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineLanguageFluencyClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 3,
            columns: languageFluencyColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { displayOrder: params.data.displayOrder, search: [params.data.name, params.data.status, params.data.displayOrder].join(' ') });
            },
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState) && !allowManageSkillsAndTrainingsClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultLanguageFluencyData,
        publicData: [
            {
                displayOrder: true,
            },
        ],
    }, languageFluencySchema);
}
